// extracted by mini-css-extract-plugin
module.exports = {"badge":"profile-image-skins-xlarge-badge-77ad640d"};